import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import caretDown from '../../../../assets/images/icons/caret-down.svg';
import { isMobile } from '../../../screenUtils';

function DropdownIndicator(props) {
  const { menuIsOpen } = props.selectProps;
  const customStyle = {
    transform: menuIsOpen ? 'rotate(180deg)' : undefined,
    marginTop: '8px',
    marginBottom: '8px',
    marginRight: isMobile() ? '2px' : '8px',
    marginLeft: isMobile() ? '-6px' : 0,
  };

  return (
    <components.DropdownIndicator {...props}>
      <img src={caretDown} alt="caret-down" style={customStyle} />
    </components.DropdownIndicator>
  );
}

DropdownIndicator.propTypes = {
  selectProps: PropTypes.shape({
    menuIsOpen: PropTypes.bool,
  }),
};

DropdownIndicator.defaultProps = {
  selectProps: {},
};

export default DropdownIndicator;
